// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Floats over the bottom of the page: never moves the layout. Left of the floating chat button. */
.srcq {
  position: fixed;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  z-index: 998;
  width: min(560px, calc(100vw - 32px));
  box-sizing: border-box;
  padding: 14px 40px 14px 16px;
  background: #ffffff;
  border: 1px solid #e6e3f2;
  border-radius: 14px;
  box-shadow: 0 12px 32px rgba(32, 16, 80, 0.14);
  font-family: inherit;
  animation: srcq-in 0.25s ease-out;
}

@keyframes srcq-in {
  from { opacity: 0; transform: translate(-50%, 8px); }
  to { opacity: 1; transform: translate(-50%, 0); }
}

.srcq-title {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 600;
  color: #1d1636;
}

.srcq-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.srcq-chip {
  padding: 5px 11px;
  font-size: 12.5px;
  line-height: 1.3;
  color: #2c2550;
  background: #f5f3fc;
  border: 1px solid #e4e0f5;
  border-radius: 999px;
  cursor: pointer;
  transition: background 0.15s, border-color 0.15s;
}

.srcq-chip:hover,
.srcq-chip:focus-visible {
  background: #ece7fd;
  border-color: #5616ea;
  outline: none;
}

.srcq-close {
  position: absolute;
  top: 8px;
  right: 10px;
  width: 26px;
  height: 26px;
  font-size: 18px;
  line-height: 1;
  color: #8a84a3;
  background: transparent;
  border: none;
  border-radius: 6px;
  cursor: pointer;
}

.srcq-close:hover {
  background: #f2f0f8;
  color: #1d1636;
}

.srcq-other {
  display: flex;
  gap: 8px;
}

.srcq-other input {
  flex: 1 1;
  min-width: 0;
  padding: 7px 10px;
  font-size: 13px;
  border: 1px solid #ddd8ee;
  border-radius: 8px;
}

.srcq-send {
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  color: #fff;
  background: #5616ea;
  border: none;
  border-radius: 8px;
  cursor: pointer;
}

.srcq-thanks {
  margin: 0;
  font-size: 14px;
  font-weight: 600;
  color: #1d1636;
}

@media (max-width: 640px) {
  .srcq {
    bottom: 12px;
    padding: 12px 36px 12px 12px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/SourceQuestion.css"],"names":[],"mappings":"AAAA,kGAAkG;AAClG;EACE,eAAe;EACf,SAAS;EACT,YAAY;EACZ,2BAA2B;EAC3B,YAAY;EACZ,qCAAqC;EACrC,sBAAsB;EACtB,4BAA4B;EAC5B,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,8CAA8C;EAC9C,oBAAoB;EACpB,iCAAiC;AACnC;;AAEA;EACE,OAAO,UAAU,EAAE,+BAA+B,EAAE;EACpD,KAAK,UAAU,EAAE,6BAA6B,EAAE;AAClD;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;EACpB,eAAe;EACf,gDAAgD;AAClD;;AAEA;;EAEE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,WAAW;EACX,YAAY;EACZ,eAAe;EACf,cAAc;EACd,cAAc;EACd,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,YAAY;IACZ,4BAA4B;EAC9B;AACF","sourcesContent":["/* Floats over the bottom of the page: never moves the layout. Left of the floating chat button. */\n.srcq {\n  position: fixed;\n  left: 50%;\n  bottom: 20px;\n  transform: translateX(-50%);\n  z-index: 998;\n  width: min(560px, calc(100vw - 32px));\n  box-sizing: border-box;\n  padding: 14px 40px 14px 16px;\n  background: #ffffff;\n  border: 1px solid #e6e3f2;\n  border-radius: 14px;\n  box-shadow: 0 12px 32px rgba(32, 16, 80, 0.14);\n  font-family: inherit;\n  animation: srcq-in 0.25s ease-out;\n}\n\n@keyframes srcq-in {\n  from { opacity: 0; transform: translate(-50%, 8px); }\n  to { opacity: 1; transform: translate(-50%, 0); }\n}\n\n.srcq-title {\n  margin: 0 0 10px;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1d1636;\n}\n\n.srcq-chips {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 6px;\n}\n\n.srcq-chip {\n  padding: 5px 11px;\n  font-size: 12.5px;\n  line-height: 1.3;\n  color: #2c2550;\n  background: #f5f3fc;\n  border: 1px solid #e4e0f5;\n  border-radius: 999px;\n  cursor: pointer;\n  transition: background 0.15s, border-color 0.15s;\n}\n\n.srcq-chip:hover,\n.srcq-chip:focus-visible {\n  background: #ece7fd;\n  border-color: #5616ea;\n  outline: none;\n}\n\n.srcq-close {\n  position: absolute;\n  top: 8px;\n  right: 10px;\n  width: 26px;\n  height: 26px;\n  font-size: 18px;\n  line-height: 1;\n  color: #8a84a3;\n  background: transparent;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n}\n\n.srcq-close:hover {\n  background: #f2f0f8;\n  color: #1d1636;\n}\n\n.srcq-other {\n  display: flex;\n  gap: 8px;\n}\n\n.srcq-other input {\n  flex: 1;\n  min-width: 0;\n  padding: 7px 10px;\n  font-size: 13px;\n  border: 1px solid #ddd8ee;\n  border-radius: 8px;\n}\n\n.srcq-send {\n  padding: 7px 14px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #fff;\n  background: #5616ea;\n  border: none;\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.srcq-thanks {\n  margin: 0;\n  font-size: 14px;\n  font-weight: 600;\n  color: #1d1636;\n}\n\n@media (max-width: 640px) {\n  .srcq {\n    bottom: 12px;\n    padding: 12px 36px 12px 12px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
